<template>
  <div class="home">
    <aside class="asideBar">
    <Sidebar/>
</aside>
    <section class="wrapperMaincontent">
    <GraphicArea/>
    <Specification/>

    </section>

    <b-modal :active.sync="showInfoModal" :can-cancel="false" has-modal-card>
      <div class="modal-card">
        <section class="modal-card-body">
          <img src="@/assets/logo-kalls.svg" alt="Källs logotyp" class="modal-logo" />
          <p>Tänk på att grenställsbyggaren bara är ett hjälpmedel, för att få en översyn av ditt grenställ. Eventuella belastningar <strong>MÅSTE</strong> kontrolleras med KÄLLS.</p>
        </section>
        <footer class="modal-card-foot">
          <b-button class="ok-btn" @click="showInfoModal = false">OK</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/Sidebar.vue'
import Specification from '@/components/Specification.vue'
import GraphicArea from '@/components/GraphicArea.vue'

export default {
  name: 'Grenstall',
  components: {
    Sidebar,
    Specification,
    GraphicArea
  },
  data() {
    return {
      showInfoModal: true
    }
  }
}
</script>

<style scoped>
.home {
  display: flex;
}

.modal-card-foot {
  justify-content: center;
}

.modal-logo {
  display: block;
  margin: 0 auto 1rem;
}

.ok-btn {
  background-color: #10b1e0;
  color: #fff;
  border: none;
  font-weight: 600;
}

.ok-btn:hover {
  background-color: #1498bf;
  color: #fff;
}

::v-deep .modal-background {
  background-color: rgba(255, 255, 255, 0.8);
}

.modal-card {
  border-radius: 3px;
  -webkit-filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
  filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
}

.modal-card-foot {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.modal-card-body strong {
  font-weight: 700;
}
</style>
